/** Shared horizontal padding + max width for app shell sections (parent-relative, not viewport container). */
export const SHELL_CONTENT =
  'w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8';

/** Marks the main page column as a container query root (responds to pinned Mojo Agent width). */
export const MAIN_CONTENT_CONTAINER = 'shell-content-inner';

/** Grids sized to main content width — see index.css container rules. */
export const MAIN_GRID_4 = 'main-page-grid-4';
export const MAIN_GRID_3 = 'main-page-grid-3';
export const MAIN_GRID_3_UP = 'main-page-grid-3-up';
export const MAIN_GRID_2 = 'main-page-grid-2';
export const MAIN_GRID_SPLIT = 'main-page-grid-split';
export const MAIN_COL_SPAN_2 = 'main-page-col-span-2';
